export function convertToObjectBySku<T>(array: { sku_code: string }[]): {
  [sku_code: string]: T;
} {
  return array.reduce((obj, item) => {
    const { sku_code } = item;
    obj[sku_code] = item;
    return obj;
  }, {});
}
